import { NotificationBase } from './notification-base';

export class NotificationFeedback extends NotificationBase {
  process(): void {
    this.showAlert();
  }

  protected viewNotification(): void {
    this.navCtrl.navigateForward(`feedback/${this.item.id}`);
  }
}
